/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentImpersonationStatusAdminUser model module.
 * @module model/AgentImpersonationStatusAdminUser
 * @version 1.0.0
 */
class AgentImpersonationStatusAdminUser {
    /**
     * Constructs a new <code>AgentImpersonationStatusAdminUser</code>.
     * @alias module:model/AgentImpersonationStatusAdminUser
     */
    constructor() { 
        
        AgentImpersonationStatusAdminUser.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentImpersonationStatusAdminUser</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentImpersonationStatusAdminUser} obj Optional instance to populate.
     * @return {module:model/AgentImpersonationStatusAdminUser} The populated <code>AgentImpersonationStatusAdminUser</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentImpersonationStatusAdminUser();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentImpersonationStatusAdminUser</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentImpersonationStatusAdminUser</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
AgentImpersonationStatusAdminUser.prototype['id'] = undefined;

/**
 * @member {String} name
 */
AgentImpersonationStatusAdminUser.prototype['name'] = undefined;

/**
 * @member {String} email
 */
AgentImpersonationStatusAdminUser.prototype['email'] = undefined;






export default AgentImpersonationStatusAdminUser;

